import { CustomerResponseDto } from "../shared/dtos/customer/CustomerResponseDto";
import { CustomerSummaryDto } from "../shared/dtos/customer/CustomerSummaryDto";

export class CustomerMapper {
  public static mapCustomerToSummary(
    customer: CustomerResponseDto,
  ): CustomerSummaryDto {
    return {
      id: customer.id,
      name: customer.name,
      primaryContact: customer.primaryContact,
      email: customer.email,
      taxId: customer.taxId,
      creditLimit: customer.creditLimit,
      loyaltyPoints: customer.loyaltyPoints,
      isActive: customer.isActive,
    };
  }
}
